import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  IconButton,
  Divider,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { SegregationLocation_Detail } from "../../../Server/ApiV2";
import { CmpStatusIconV3 } from "../../../Component/Common/ToolBox/ToolBox";

const LocationAndItemWiseModal = ({
  open,
  handleClose,
  data,
  selectedItem,
  vMediaQuery,
}) => {
  const [viewData, setViewData] = useState([]);

  // Function to group data by Location
  function groupByLocation(data) {
    const uniqueLocations = [...new Set(data.map((item) => item.Location))];

    return uniqueLocations.map((location) => {
      const subdata = data.filter((item) => item.Location === location);
      const locationName = subdata[0]?.LocName || "Unknown"; // Fetch LocationName from the first entry

      return {
        Location: location,
        LocationName: locationName,
        subdata: subdata,
      };
    });
  }

  // Fetch and process data
  const itemAndLocationWiseData = async () => {
    const obj = {
      VocTyp: selectedItem?.A_VocTyp,
      VocNo: selectedItem?.A_VocNo,
    };
    const result = await SegregationLocation_Detail(obj);

    if (result.status === 200) {
      const updatedData = result?.data?.ResultSet.map((item) => {
        let indicator;
        if (item.BalanceQty === 0) {
          indicator = 3; // Green
        } else if (item.TotalPickedQty > 0) {
          indicator = 1; // Yellow
        } else {
          indicator = 2; // Red
        }
        return {
          ...item, // Spread existing properties
          Indicator: indicator, // Add the new key
        };
      })?.sort((a, b) => a.Indicator - b.Indicator);
      const groupedData = groupByLocation(updatedData);
      setViewData(groupedData);
    }
  };

  console.log(viewData);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        itemAndLocationWiseData();
      }, 1000);
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={()=>{
        setViewData([]);
        handleClose()
      }}
      aria-labelledby="view-segregation-modal"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: vMediaQuery ? "95%" : "75%",
          bgcolor: "white",
          boxShadow: 24,
          borderRadius: 2,
          paddingY: vMediaQuery ? 1 : 2,
          paddingX: vMediaQuery ? 1 : 3,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Header */}
        <Box display="flex" justifyContent="space-between" mb={0.5}>
          <Typography variant="h6" id="view-segregation-modal">
            Location and Item Wise
            <Typography
              variant="body2"
              color="primary"
              sx={{ cursor: "pointer", fontWeight: 600 }}
            >
              {selectedItem?.A_VocNo} , {data?.SegregationMethod}
            </Typography>
          </Typography>

          <IconButton onClick={()=>{
        setViewData([]);
        handleClose()
      }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider />

        {/* Grouped Data by Location */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: vMediaQuery ? "80vh" : "70vh",
            overflowY: "auto",
          }}
        >
          <Box
            mt={vMediaQuery ? 1 : 2}
            paddingY={vMediaQuery ? 0 : 1}
            paddingX={vMediaQuery ? 1 : 2}
          >
            {viewData.map((group, groupIndex) => (
              <Box key={groupIndex} mb={vMediaQuery ? 1 : 3}>
                {/* Location Header */}
                <Typography
                  variant={vMediaQuery ? "subtitle1" : "h6"}
                  fontWeight="bold"
                  color="primary"
                >
                  {group.LocationName}
                </Typography>

                {/* Cards for Each Location */}
                <Grid container spacing={vMediaQuery ? 1 : 2}>
                  {group.subdata.map((row, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      <Card
                        sx={{
                          width: "100%",
                          borderRadius: 3,
                          boxShadow: 2,
                          border: "1px solid #FAF9F6",
                          "& .MuiCardContent-root": {
                            padding: "5px !important",
                          },
                        }}
                      >
                        <CardContent>
                          {/* <Typography
                            variant={vMediaQuery ? "subtitle2" : "subtitle1"}
                            fontWeight="bold"
                            fontSize={vMediaQuery ? "14px" : "16px"}
                          >
                            {row?.ItemName}
                          </Typography>
 
                          <Typography
                            variant="caption"
                            color="gray"
                            sx={{ display: "block" }}
                          >
                            {row?.ItemCode}
                          </Typography> */}
                          <Box sx={{ backgroundColor: "#FAF9F6", p: 1 }}>
                            {/* Name and Position */}
                            <Grid container alignItems={'center'}>
                              <Grid item xs={11}>
                                <Typography variant="span" fontWeight="bold"   noWrap
                                    sx={{ 
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      display: "block",
                                    }}>
                                  {row.ItemName}
                                </Typography>
                              </Grid>
                              <Grid item xs={1} textAlign={"right"}>
                                <CmpStatusIconV3 xStatus={row.Indicator} />
                              </Grid>
                            </Grid>
                          </Box>
                          {/* Quantity Details */}
                          <Box
                            sx={{
                              backgroundColor: "#F4F4F4",
                              borderRadius: 2,
                              p: "1px",
                              mt: 0.5,
                            }}
                          >
                            <Grid container spacing={1}>
                              <Grid item xs={4}>
                                <Typography variant="caption" color="gray">
                                  Qty
                                </Typography>
                                <Typography
                                  variant="subtitle1"
                                  fontWeight="bold"
                                >
                                  {row.TotalBaseQty}
                                </Typography>
                              </Grid>
                              <Grid item xs={5}>
                                <Typography variant="caption" color="gray">
                                  Seg.Qty
                                </Typography>
                                <Typography
                                  variant="subtitle1"
                                  fontWeight="bold"
                                >
                                  {row.TotalPickedQty}
                                </Typography>
                              </Grid>
                              <Grid item xs={3}>
                                <Typography variant="caption" color="gray">
                                  Balance
                                </Typography>
                                <Typography
                                  variant="subtitle1"
                                  fontWeight="bold"
                                >
                                  {row.BalanceQty}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            ))}
          </Box>
        </div>
      </Box>
    </Modal>
  );
};

export default LocationAndItemWiseModal;
